<template>
  <div>
    <div class="product-add">
      <el-steps :active="stepActive" finish-status="success">
        <el-step title="签约信息"/>
        <el-step title="资质信息"/>
        <el-step title="支付款项"/>
        <el-step title="签约审核"/>
        <el-step title="开通完成"/>
      </el-steps>
    </div>
    <el-divider><span class="icon iconfont icon-weixinzhifu">&nbsp;微信支付</span></el-divider>

    <!--签约信息-->
    <el-form v-if="stepActive===0" ref="baseInfo" size="small" :model="form.baseInfo" :rules="stepForm_rules0"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--超级管理员信息-->
      <div class="common-form">主体资料</div>
      <el-form-item label="主体类型" prop="subject_type">
        <el-radio-group v-model="form.baseInfo.subject_type" @input="subjectTypeChange">
          <el-radio border label="SUBJECT_TYPE_INDIVIDUAL">个体户</el-radio>
          <el-radio border label="SUBJECT_TYPE_ENTERPRISE">企业</el-radio>
          <el-radio border label="SUBJECT_TYPE_GOVERNMENT">政府机关</el-radio>
          <el-radio border label="SUBJECT_TYPE_INSTITUTIONS">事业单位</el-radio>
          <el-radio border label="SUBJECT_TYPE_OTHERS">社会组织</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--经营资料-->
      <div class="common-form">经营资料</div>
      <el-form-item label="商户简称" prop="merchant_shortname">
        <el-input type="text" v-model="form.baseInfo.merchant_shortname" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="客服电话" prop="service_phone">
        <el-input type="text" v-model="form.baseInfo.service_phone" class="max-w460"></el-input>
      </el-form-item>

      <!--结算银行-->
      <div class="common-form">结算银行账户</div>
      <el-form-item label="账户类型" prop="bank_account_type">
        <el-radio-group v-model="form.baseInfo.bank_account_type"
                        :disabled="form.baseInfo.subject_type !== 'SUBJECT_TYPE_INDIVIDUAL'"
                        @input="bank_account_typeChange">
          <el-radio label="BANK_ACCOUNT_TYPE_PERSONAL">经营者个人银行卡</el-radio>
          <el-radio label="BANK_ACCOUNT_TYPE_CORPORATE">对公银行账户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开户名称" prop="account_name">
        <el-input type="text" v-model="form.baseInfo.account_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="银行账号" prop="account_number">
        <el-input v-model="form.baseInfo.account_number" type="number" class="max-w460"
                  @change="searchBanksByBankAccount"></el-input>
      </el-form-item>
      <el-form-item label="开户银行所在地" prop="bank_address_code">
        <el-cascader
          ref="areaCascader"
          placeholder="开户银行所在地"
          v-model="form.baseInfo.bank_address_code"
          :options="areaList"
          filterable
          class="max-w460 f-item"
          @change="handleBankAddressChange"></el-cascader>
      </el-form-item>
      <el-form-item label="开户银行" prop="account_bank">
        <el-select size="small" v-model="form.baseInfo.account_bank" placeholder="开户银行" class="max-w460 f-item">
          <el-option v-for="(item, index) in bankList" :key="index" :label="item.mergerName"
                     :value="item.mergerName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开户银行支行" prop="bank_branch_id" v-if="form.baseInfo.account_bank ==='其他银行'">
        <el-autocomplete
          popper-class="bank-autocomplete"
          class="max-w460 f-item"
          v-model="form.baseInfo.bank_branch_id"
          :fetch-suggestions="getBankBranchList"
          placeholder="请输开户银行支行"
          @select="handleBankSelect"
        >
          <i
            class="el-icon-edit el-input__icon"
            slot="suffix">
          </i>
          <template slot-scope="{ item }">
            <div class="name">{{ item.mergerName }}</div>
            <span class="code">{{ `联行号：${item.number}` }}</span>
          </template>
        </el-autocomplete>
        <el-input type="hidden" v-model="form.baseInfo.bank_branch_id"></el-input>
      </el-form-item>
    </el-form>

    <!--资质信息-->
    <el-form v-if="stepActive===1" ref="qualificationInfo" size="small" :model="form.qualificationInfo"
             :rules="stepForm_rules1"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--营业执照-->
      <div class="common-form"
           v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_INDIVIDUAL'||form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        营业执照
      </div>
      <div class="common-form"
           v-else-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_GOVERNMENT'||form.baseInfo.subject_type === 'SUBJECT_TYPE_INSTITUTIONS'||form.baseInfo.subject_type === 'SUBJECT_TYPE_OTHERS'">
        登记证书
      </div>
      <el-form-item label="营业执照照片" prop="license_copy"
                    v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_INDIVIDUAL'||form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('license_copy')">选择图片</el-button>
          <div v-if="form.qualificationInfo.license_copy !== undefined" class="img">
            <img :src="license_copyFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="登记证书照片" prop="cert_copy"
                    v-else-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_GOVERNMENT'||form.baseInfo.subject_type === 'SUBJECT_TYPE_INSTITUTIONS'||form.baseInfo.subject_type === 'SUBJECT_TYPE_OTHERS'">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('cert_copy')">选择图片</el-button>
          <div v-if="form.qualificationInfo.cert_copy !== undefined" class="img">
            <img :src="cert_copyFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="登记证书类型" prop="cert_type"
                    v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_GOVERNMENT'||form.baseInfo.subject_type === 'SUBJECT_TYPE_INSTITUTIONS'||form.baseInfo.subject_type === 'SUBJECT_TYPE_OTHERS'">

        <template slot="label">
            <span>登记证书类型
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>当主体为事业单位时，选择此枚举值：</p>
                  <p>CERTIFICATE_TYPE_2388：事业单位法人证书</p>
                  <p>当主体为政府机关，选择此枚举值：</p>
                  <p>CERTIFICATE_TYPE_2389：统一社会信用代码证书</p>
                </div>
              </el-tooltip>
            </span>
        </template>
        <el-radio-group v-model="form.qualificationInfo.cert_type">
          <el-radio border label="CERTIFICATE_TYPE_2389">统一社会信用代码证书</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2394">社会团体法人登记证书</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2395">民办非企业单位登记证书</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2396">基金会法人登记证书</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2520">执业许可证/执业证</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2521">基层群众性自治组织特别法人统一社会信用代码证</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2522">农村集体经济组织登记证</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2399">宗教活动场所登记证</el-radio>
          <el-radio border label="CERTIFICATE_TYPE_2400">政府部门下发的其他有效证明文件</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="注册号/统一社会信用代码" prop="license_number"
                    v-if="form.qualificationInfo.subject_type === 'SUBJECT_TYPE_INDIVIDUAL'||form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        <el-input type="text" v-model="form.qualificationInfo.license_number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="证书号" prop="cert_number"
                    v-else-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_INDIVIDUAL'||form.baseInfo.subject_type === 'SUBJECT_TYPE_GOVERNMENT'||form.baseInfo.subject_type === 'SUBJECT_TYPE_INSTITUTIONS'||form.baseInfo.subject_type === 'SUBJECT_TYPE_OTHERS'">
        <el-input type="text" v-model="form.qualificationInfo.cert_number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户名称" prop="merchant_name">
        <el-input type="text" v-model="form.qualificationInfo.merchant_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="个体户经营者/法人姓名" prop="legal_person">
        <el-input v-model="form.qualificationInfo.legal_person" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="注册地址" prop="license_address"
                    v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_INDIVIDUAL'||form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        <el-input v-model="form.qualificationInfo.license_address" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="注册地址" prop="company_address"
                    v-else-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_GOVERNMENT'||form.baseInfo.subject_type === 'SUBJECT_TYPE_INSTITUTIONS'||form.baseInfo.subject_type === 'SUBJECT_TYPE_OTHERS'">
        <el-input v-model="form.qualificationInfo.company_address" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="有效期类型" prop="period_type">
        <el-radio-group v-model="form.qualificationInfo.period_type" @input="period_typeChange">
          <el-radio label="0">定期</el-radio>
          <el-radio label="1">长期有效</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有效期限开始日期" prop="period_begin">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.period_begin"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddStart(form.qualificationInfo.period_end)'
          @change="($event)=>limitPeriodDate('start',$event)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="有效期限结束日期" prop="period_end" v-if="form.qualificationInfo.period_type ==='0'">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.period_end"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddEnd(form.qualificationInfo.period_begin)'
          @change="($event)=>limitPeriodDate('end',$event)"
        ></el-date-picker>
      </el-form-item>

      <!--超级管理员信息-->
      <div class="common-form">经营者/法人身份证件</div>
      <el-form-item label="证件持有人类型" prop="id_holder_type">
        <el-radio-group v-model="form.qualificationInfo.id_holder_type">
          <el-radio border label="LEGAL">经营者/法人</el-radio>
          <el-radio border label="SUPER" disabled>经办人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="证件类型" prop="id_doc_type">
        <el-select v-model="form.qualificationInfo.id_doc_type" placeholder="请选择">
          <el-option label="中国大陆居民-身份证" value="IDENTIFICATION_TYPE_IDCARD"></el-option>
          <el-option label="其他国家或地区居民-护照" value="IDENTIFICATION_TYPE_OVERSEA_PASSPORT" disabled>
          </el-option>
          <el-option label="中国香港居民-来往内地通行证" value="IDENTIFICATION_TYPE_HONGKONG_PASSPORT" disabled>
          </el-option>
          <el-option label="中国澳门居民-来往内地通行证" value="IDENTIFICATION_TYPE_MACAO_PASSPORT" disabled>
          </el-option>
          <el-option label="中国台湾居民-来往大陆通行证" value="IDENTIFICATION_TYPE_TAIWAN_PASSPORT" disabled>
          </el-option>
          <el-option label="外国人居留证" value="IDENTIFICATION_TYPE_FOREIGN_RESIDENT" disabled>
          </el-option>
          <el-option label="台湾居民证" value="IDENTIFICATION_TYPE_HONGKONG_MACAO_RESIDENT" disabled>
          </el-option>
          <el-option label="台湾居民证" value="IDENTIFICATION_TYPE_TAIWAN_RESIDENT" disabled></el-option>
        </el-select>
      </el-form-item>

      <!--营业执照-->
      <div class="common-form">身份证信息</div>
      <el-form-item label="身份证人像面照片" prop="id_card_copy">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('id_card_copy')">选择图片</el-button>
          <div v-if="form.qualificationInfo.id_card_copy !== undefined" class="img">
            <img :src="id_card_copyFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="身份证国徽面照片" prop="id_card_national">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('id_card_national')">选择图片</el-button>
          <div v-if="form.qualificationInfo.id_card_national !== undefined" class="img">
            <img :src="id_card_nationalFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="身份证姓名" prop="id_card_name">
        <el-input type="text" v-model="form.qualificationInfo.id_card_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码" prop="id_card_number">
        <el-input type="text" v-model="form.qualificationInfo.id_card_number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="身份证居住地址" prop="id_card_address">
        <el-input v-model="form.qualificationInfo.id_card_address" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="身份证有效期类型" prop="card_period_type">
        <el-radio-group v-model="form.qualificationInfo.card_period_type" @input="card_period_typeChange">
          <el-radio label="0">定期</el-radio>
          <el-radio label="1">长期有效</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="身份证有效期开始时间" prop="card_period_begin">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.card_period_begin"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddStart(form.qualificationInfo.card_period_end)'
          @change="($event)=>limitDate('start',$event)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="身份证有效期结束时间" prop="card_period_end"
                    v-if="form.qualificationInfo.card_period_type ==='0'">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.card_period_end"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddEnd(form.qualificationInfo.card_period_begin)'
          @change="($event)=>limitDate('end',$event)"
        ></el-date-picker>
      </el-form-item>

      <!--超级管理员信息-->
      <div class="common-form">经营场景</div>
      <el-form-item label="经营场景类型" prop="sales_scenes_type">
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">1、请勾选实际售卖商品/提供服务场景（至少一项），以便为你开通需要的支付权限。<br/>2、建议只勾选目前必须的场景，以便尽快通过入驻审核，其他支付权限可在入驻后再根据实际需要发起申请。
          </div>
          <el-checkbox-group v-model="form.qualificationInfo.sales_scenes_type" @input="sales_scenes_typeChange">
            <el-checkbox-button key="SALES_SCENES_MP" label="SALES_SCENES_MP">公众号</el-checkbox-button>
            <el-checkbox-button key="SALES_SCENES_STORE" label="SALES_SCENES_STORE">线下场所
            </el-checkbox-button>
            <el-checkbox-button key="SALES_SCENES_MINI_PROGRAM" label="SALES_SCENES_MINI_PROGRAM">小程序
            </el-checkbox-button>
            <el-checkbox-button key="SALES_SCENES_WEB" label="SALES_SCENES_WEB">互联网网站</el-checkbox-button>
            <el-checkbox-button key="SALES_SCENES_APP" label="SALES_SCENES_APP" disabled>APP</el-checkbox-button>
            <el-checkbox-button key="SALES_SCENES_WEWORK" label="SALES_SCENES_WEWORK" disabled>企业微信
            </el-checkbox-button>
          </el-checkbox-group>
        </el-tooltip>
      </el-form-item>

      <!--公众号场景-->
      <div v-if="form.qualificationInfo.sales_scenes_type.includes('SALES_SCENES_MP')">
        <div class="common-form">公众号场景</div>
        <el-form-item label="服务商公众号AppID" prop="mp_appid">
          <el-input type="text" v-model="form.qualificationInfo.mp_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商家公众号AppID" prop="mp_sub_appid">
          <el-input type="text" v-model="form.qualificationInfo.mp_sub_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="公众号页面截图" prop="mp_pics">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualificationInfo.mp_pics">
              <transition-group>
                <div class="item" v-for="(item, index) in form.qualificationInfo.mp_pics" :key="item.imageId">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn"
                     @click.stop="deleteImg(form.qualificationInfo.mp_pics,index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload( 'mp_pics')"><i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
      </div>

      <!--线下场所场景-->
      <div v-if="form.qualificationInfo.sales_scenes_type.includes('SALES_SCENES_STORE')">
        <div class="common-form">线下场所场景</div>
        <el-form-item label="线下场所名称" prop="biz_store_name">
          <el-input type="text" v-model="form.qualificationInfo.biz_store_name" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="线下场所省市编码" prop="biz_address_code">
          <el-input type="text" v-model="form.qualificationInfo.biz_address_code" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="线下场所地址" prop="biz_store_address">
          <el-input type="text" v-model="form.qualificationInfo.biz_store_address" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="线下场所对应的商家AppID" prop="biz_sub_appid">
          <el-input type="text" v-model="form.qualificationInfo.biz_sub_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="线下场所门头照片" prop="store_entrance_pic">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualificationInfo.store_entrance_pic">
              <transition-group>
                <div class="item" v-for="(item, index) in form.qualificationInfo.store_entrance_pic"
                     :key="item.imageId">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn"
                     @click.stop="deleteImg(form.qualificationInfo.store_entrance_pic,index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload( 'store_entrance_pic')"><i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="线下场所内部照片" prop="indoor_pic">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualificationInfo.indoor_pic">
              <transition-group>
                <div class="item" v-for="(item, index) in form.qualificationInfo.indoor_pic" :key="item.imageId">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn"
                     @click.stop="deleteImg(form.qualificationInfo.indoor_pic,index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload( 'indoor_pic')"><i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
      </div>

      <!--小程序场景-->
      <div v-if="form.qualificationInfo.sales_scenes_type.includes('SALES_SCENES_MINI_PROGRAM')">
        <div class="common-form">小程序场景</div>
        <el-form-item label="服务商小程序APPID" prop="mini_program_appid">
          <el-input type="text" v-model="form.qualificationInfo.mini_program_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商家小程序APPID" prop="mini_program_sub_appid">
          <el-input type="text" v-model="form.qualificationInfo.mini_program_sub_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="小程序截图" prop="mini_program_pics">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualificationInfo.image">
              <transition-group>
                <div class="item" v-for="(item, index) in form.qualificationInfo.mini_program_pics" :key="item.imageId">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn"
                     @click.stop="deleteImg(form.qualificationInfo.mini_program_pics,index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload('mini_program_pics')"><i
              class="el-icon-plus"></i></div>
          </div>
        </el-form-item>
      </div>

      <!--App场景-->
      <div v-if="form.qualificationInfo.sales_scenes_type.includes('SALES_SCENES_APP')">
        <div class="common-form">App场景</div>
        <el-form-item label="服务商应用APPID" prop="app_appid">
          <el-input type="text" v-model="form.qualificationInfo.app_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商家应用APPID" prop="app_sub_appid">
          <el-input type="text" v-model="form.qualificationInfo.app_sub_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="APP截图" prop="app_pics">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualificationInfo.app_pics">
              <transition-group>
                <div class="item" v-for="(item, index) in form.qualificationInfo.app_pics" :key="item.imageId">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn"
                     @click.stop="deleteImg(form.qualificationInfo.app_pics,index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload('app_pics')"><i
              class="el-icon-plus"></i></div>
          </div>
        </el-form-item>
      </div>

      <!--互联网网站场景-->
      <div v-if="form.qualificationInfo.sales_scenes_type.includes('SALES_SCENES_APP')">
        <div class="common-form">互联网网站场景</div>
        <el-form-item label="互联网网站域名" prop="domain">
          <el-input type="text" v-model="form.qualificationInfo.domain" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="互联网网站对应的商家APPID" prop="app_sub_appid">
          <el-input type="text" v-model="form.qualificationInfo.web_appid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="网站授权函" prop="web_authorisation">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.qualificationInfo.image">
              <transition-group>
                <div class="item" v-for="(item, index) in form.qualificationInfo.mini_program_pics" :key="item.imageId">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn"
                     @click.stop="deleteImg(form.qualificationInfo.mini_program_pics,index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload('mini_program_pics')"><i
              class="el-icon-plus"></i></div>
          </div>
        </el-form-item>
      </div>

      <!--超级管理员信息-->
      <div class="common-form">超级管理员信息</div>
      <el-form-item label="超级管理员类型" prop="contact_type">
        <el-radio-group v-model="form.qualificationInfo.contact_type">
          <el-radio label="LEGAL">经营者/法人</el-radio>
          <el-radio label="SUPER" disabled>经办人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="超级管理员姓名" prop="contact_name">
        <el-input type="text" v-model="form.qualificationInfo.contact_name" prefix-icon="el-icon-user" clearable
                  :placeholder="$t('login.user')" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="超级管理员联系手机" prop="mobile_phone">
        <el-input v-model="form.qualificationInfo.mobile_phone" prefix-icon="el-icon-phone" clearable class="max-w460"
                  :placeholder="$t('login.mobilePlaceholder')">
        </el-input>
      </el-form-item>
      <el-form-item label="超级管理员联系邮箱" prop="contact_email">
        <el-input v-model="form.qualificationInfo.contact_email" prefix-icon="el-icon-goods" clearable
                  :placeholder="$t('login.emailPlaceholder')" class="max-w460"></el-input>
      </el-form-item>
    </el-form>

    <!--支付款项-->
    <el-form v-if="stepActive===2" ref="stepForm_2" size="small" :model="form.pay" :rules="stepForm_rules2"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--超级管理员信息-->
      <div class="common-form">支付款项</div>
      <el-select v-model="form.pay.activities_rate" placeholder="请选择">
        <el-option label="零售（0.6%，T+1）" value="0.6"></el-option>
      </el-select>
    </el-form>

    <!--签约审核-->
    <el-form v-if="stepActive===3" ref="stepForm_3" size="small" :model="stepForm_3" :rules="stepForm_rules3"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--超级管理员信息-->
      <div class="common-form">超级管理员信息</div>
    </el-form>

    <!--开通完成-->
    <div v-if="stepActive===4">
      <el-result icon="success" title="注册成功" sub-title="审核完成后，您可以使用登录账号以及手机号登录系统">
        <template #extra>
          <el-button type="primary" @click="goLogin">前去登录</el-button>
        </template>
      </el-result>
    </div>

    <div class="common-button-wrapper">
      <!--      <el-button type="danger" @click="repickPayType">选择平台</el-button>-->
      <el-button v-if="stepActive>0 && stepActive<3" @click="pre">上一步</el-button>
      <el-button v-if="stepActive<2" type="primary" @click="next">下一步</el-button>
      <el-button v-if="stepActive===2" type="primary" @click="doSave">提交</el-button>
    </div>

    <!--上传图片组件-->
    <Upload v-if="isupload" :config="uploadConfig" :isupload="isupload" @returnImgs="returnImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import SubApplymentApi from '@/api/subApplyment.js';
import DataApi from '@/api/data.js';
import Upload from '@/components/file/Upload';
import moment from 'moment'
import {isNil} from 'lodash-es';

export default {
  name: "WepayApply",
  props: {
    payInfo: {
      type: Object,
      default: {}
    },
  },
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      loading: false,
      stepActive: 0,
      uploadConfig: {
        uploadType: 'Local'
      },
      /*切换菜单*/
      license_copyFilePath: '',
      cert_copyFilePath: '',
      id_card_copyFilePath: '',
      id_card_nationalFilePath: '',
      /*是否上传图片*/
      isupload: false,
      /*银行列表*/
      bankList: [],
      /*省市区*/
      areaList: [],
      fileType: 'logo',
      /*form表单数据*/
      form: {
        applymentId: '',
        applymentNo: '',
        applymentType: 20,
        baseInfo: {
          subject_type: 'SUBJECT_TYPE_INDIVIDUAL',
          merchant_shortname: '',
          service_phone: '',
          bank_account_type: 'BANK_ACCOUNT_TYPE_PERSONAL',
          account_name: '',
          account_bank: '',
          account_number: '',
          bank_name: '',
          bank_branch_id: '',
          bank_address_code: '',
        },
        qualificationInfo: {
          contact_type: 'LEGAL',
          contact_name: '',
          mobile_phone: '',
          contact_email: '',
          license_copy: undefined,
          cert_copy: undefined,
          license_number: '',
          cert_number: '',
          merchant_name: '',
          legal_person: '',
          license_address: '',
          company_address: '',
          period_begin: '',
          period_end: '',
          id_holder_type: 'LEGAL',
          id_doc_type: 'IDENTIFICATION_TYPE_IDCARD',
          id_card_copy: undefined,
          id_card_national: undefined,
          id_card_name: '',
          id_card_number: '',
          id_card_address: '',
          card_period_type: '0',
          period_type: '0',
          card_period_begin: '',
          card_period_end: '',
          sales_scenes_type: [],
          mini_program_appid: '',
          mini_program_sub_appid: '',
          mini_program_pics: [],
          store_entrance_pic: [],
          indoor_pic: [],
          domain: '',
          web_authorisation: '',
          mp_appid: '',
          biz_store_name: '',
          biz_address_code: '',
          biz_store_address: '',
          biz_sub_appid: '',
          mp_sub_appid: '',
          mp_pics: [],
          app_appid: '',
          app_sub_appid: '',
          app_pics: [],
        },
        pay: {
          activities_rate: '0.6',
        },
        stepForm_3: {},
        stepForm_4: {},
      },
      stepForm_rules0: {
        subject_type: [
          {required: true, message: '请选择主体类型'}
        ],
        merchant_shortname: [
          {required: true, message: '请输入商户简称'}
        ],
        service_phone: [
          {required: true, message: '请输入客服电话'}
        ],
        bank_account_type: [
          {required: true, message: '请选择账户类型'}
        ],
        account_name: [
          {required: true, message: '请输入开户名称'}
        ],
        account_bank: [
          {required: true, message: '请选择开户银行'}
        ],
        bank_name: [
          {required: true, message: '请选择开户银行支行'}
        ],
        account_number: [
          {required: true, message: '请输入银行账号'}
        ],
        bank_address_code: [
          {required: true, message: '请选择开户银行所在地'}
        ],
      },
      stepForm_rules1: {
        contact_type: [
          {required: true, message: '请选择超级管理员类型'}
        ],
        contact_name: [
          {required: true, message: '请输入超级管理员姓名', trigger: ['blur', 'change']}
        ],
        mobile_phone: [
          {required: true, message: '请输入超级管理员联系手机', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        contact_email: [
          {required: true, message: '请输入超级管理员联系邮箱', trigger: 'blur'},
          {
            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: ['blur', 'change']
          }
        ],
        license_copy: [
          {required: true, message: '请上传营业执照照片'}
        ],
        cert_copy: [
          {required: true, message: '请上传登记证书照片'}
        ],
        license_number: [
          {required: true, message: '请输入注册号/统一社会信用代码'}
        ],
        cert_number: [
          {required: true, message: '请输入证书号'}
        ],
        merchant_name: [
          {required: true, message: '请输入商户名称'}
        ],
        legal_person: [
          {required: true, message: '请输入个体户经营者/法人姓名'}
        ],
        license_address: [
          {required: true, message: '请输入注册地址'}
        ],
        company_address: [
          {required: true, message: '请输入注册地址'}
        ],
        cert_type: [
          {required: true, message: '请选择登记证书类型'}
        ],
        period_begin: [
          {required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change']}
        ],
        period_end: [
          {required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change']}
        ],
        id_holder_type: [
          {required: true, message: '请选择经营者/法人身份证件'}
        ],
        id_doc_type: [
          {required: true, message: '请选择证件类型'}
        ],
        id_card_copy: [
          {required: true, message: '请上传身份证人像面照片'}
        ],
        id_card_national: [
          {required: true, message: '请上传身份证国徽面照片'}
        ],
        id_card_name: [
          {required: true, message: '请输入身份证姓名'}
        ],
        id_card_number: [
          {required: true, message: '请输入身份证号码'}
        ],
        id_card_address: [
          {required: true, message: '请输入身份证居住地址'}
        ],
        card_period_type: [
          {required: true, message: '请选择身份证有效期类型'}
        ],
        card_period_begin: [
          {required: true, message: '请选择身份证有效期限开始日期', trigger: ['blur', 'change']}
        ],
        card_period_end: [
          {required: true, message: '请选择身份证有效期限结束日期', trigger: ['blur', 'change']}
        ],
        mini_program_appid: [
          {required: true, message: '请输入服务商小程序APPID'}
        ],
        mini_program_sub_appid: [
          {required: true, message: '请输入商家小程序APPID'}
        ],
        mp_appid: [
          {required: true, message: '请输入服务商公众号APPID'}
        ],
        mp_sub_appid: [
          {required: true, message: '请输入商家公众号APPID'}
        ],
        app_appid: [
          {required: true, message: '请输入服务商应用APPID'}
        ],
        app_sub_appid: [
          {required: true, message: '请输入商家应用APPID'}
        ],
        // sales_scenes_type: [
        //   {type: 'array', required: true, message: '请选择经营场景类型'}
        // ],
        mini_program_pics: [
          {required: true, message: '请上传小程序截图'}
        ],
        domain: [
          {required: true, message: '请输入互联网网站域名'}
        ],
        web_authorisation: [
          {required: true, message: '请上传网站授权函'}
        ],

      },
      stepForm_rules2: {},
      stepForm_rules3: {},
      stepForm_rules4: {},
      pickerAddStart(val) {
        return {
          disabledDate(time) {
            if (val) {
              const start = moment(new Date(val), 'YYYY-MM-DD')
              return moment(time.getTime()).isAfter(start);
            }
          },
        }
      },
      pickerAddEnd(val) {
        return {
          disabledDate(time) {
            if (val) {
              const start = moment(new Date(val), 'YYYY-MM-DD')
              return moment(time.getTime()).isBefore(start);
            }
          },
        }
      },
    }
  },
  inject: [],
  mounted() {
    this.getAreaData();
    this.getBankList();
  },
  methods: {
    // 添加这个方法是因为，点击“确定”按钮会获取到当前时间，不受picker-options的限制并赋值到输入框中
    limitDate(type, date) {
      var dateTime = new Date(date).getTime();
      //开始时间的时间戳不能大于结束时间
      if (type === "start" && dateTime && this.form.qualificationInfo.card_period_end && dateTime > new Date(this.form.qualificationInfo.card_period_end).getTime()) {
        this.$message.error("开始时间不能大于结束时间！");
        this.form.qualificationInfo.card_period_begin = "";
      }
      if (type === "end" && dateTime && this.form.qualificationInfo.card_period_begin && dateTime < new Date(this.form.qualificationInfo.card_period_begin).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.form.qualificationInfo.card_period_end = "";
      }
    },
    limitPeriodDate(type, date) {
      var dateTime = new Date(date).getTime();
      //开始时间的时间戳不能大于结束时间
      if (type === "start" && dateTime && this.form.qualificationInfo.period_end && dateTime > new Date(this.form.qualificationInfo.period_end).getTime()) {
        this.$message.error("开始时间不能大于结束时间！");
        this.form.qualificationInfo.period_begin = "";
      }
      if (type === "end" && dateTime && this.form.qualificationInfo.period_begin && dateTime < new Date(this.form.qualificationInfo.period_begin).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.form.qualificationInfo.period_end = "";
      }
    },
    sales_scenes_typeChange() {

    },
    repickPayType() {

    },
    pre() {
      this.stepActive -= 1
    },
    getFormName() {
      let text = '';
      switch (this.stepActive) {
        case 0:
          text = 'baseInfo'
          break;
        case 1:
          text = 'qualificationInfo'
          break;
        case 2:
          text = 'stepForm_2'
          break;
        case 3:
          text = 'stepForm_3'
          break;
      }
      return text;
    },
    next() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (self.stepActive < 5) {
            self.stepActive += 1
          }
        } else {
          return false
        }
      })
    },
    doSave() {
      let self = this;
      if (self.payInfo.op === 'edit') {
        self.onEditSubmit();
      } else {
        self.save();
      }
    },
    save() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.loading = true;
          let Params = {
            ...self.form
          };
          SubApplymentApi.addWxApplyment(Params)
            .then(res => {
              self.loading = false;
              self.stepActive += 1
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          return false
        }
      })
    },
    //提交表单
    onEditSubmit() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.loading = true;
          let Params = {
            ...self.form
          };
          SubApplymentApi.editWxApplyment(Params)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，编辑成功',
                type: 'success'
              });
              self.$router.push('/setting/applyment/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*上传*/
    openUpload(e) {
      this.fileType = e;
      this.isupload = true;
      if (this.fileType === 'license_copy' || this.fileType === 'cert_copy' || this.fileType === 'id_card_national' || this.fileType === 'id_card_copy') {
        this.uploadConfig = {
          total: 1,
          maxSelect: 1,
          uploadType: 'Local',
          fileType: 'image'
        };
      } else if (this.fileType === 'mp_pics' || this.fileType === 'app_pics' || this.fileType === 'mini_program_pics' || this.fileType === 'store_entrance_pic' || this.fileType === 'indoor_pic' || this.fileType === 'qualifications' || this.fileType === 'activities_additions') {
        this.uploadConfig = {
          total: 5,
          maxSelect: 5,
          uploadType: 'Local',
          fileType: 'image'
        };
      }
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.fileType == 'license_copy') {
          this.license_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.license_copy = e[0];
        } else if (this.fileType == 'cert_copy') {
          this.cert_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.cert_copy = e[0];
        } else if (this.fileType == 'id_card_national') {
          this.id_card_nationalFilePath = e[0].filePath;
          this.form.qualificationInfo.id_card_national = e[0];
        } else if (this.fileType == 'id_card_copy') {
          this.id_card_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.id_card_copy = e[0];
        } else if (this.fileType == 'mp_pics') {
          let imgs = this.form.qualificationInfo.mp_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'mp_pics', imgs);
        } else if (this.fileType == 'mini_program_pics') {
          let imgs = this.form.qualificationInfo.mini_program_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'mini_program_pics', imgs);
        } else if (this.fileType == 'store_entrance_pic') {
          let imgs = this.form.qualificationInfo.store_entrance_pic.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'store_entrance_pic', imgs);
        } else if (this.fileType == 'indoor_pic') {
          let imgs = this.form.qualificationInfo.indoor_pic.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'indoor_pic', imgs);
        } else if (this.fileType == 'app_pics') {
          let imgs = this.form.qualificationInfo.app_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'app_pics', imgs);
        }

      }
      this.isupload = false;
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*删除设备图片*/
    deleteImg(arry, index) {
      arry.splice(index, 1);
    },
    //提交表单
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          SubApplymentApi.addWxApplyment(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/setting/applyment/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    subjectTypeChange(e) {
      let self = this;
      if (e !== 'SUBJECT_TYPE_INDIVIDUAL') {
        self.form.baseInfo.bank_account_type = 'BANK_ACCOUNT_TYPE_CORPORATE';
      } else if (e === 'SUBJECT_TYPE_INDIVIDUAL') {
        self.form.baseInfo.bank_account_type = 'BANK_ACCOUNT_TYPE_PERSONAL';
      }
      // self.form.baseInfo.account_name = '';
      // self.form.baseInfo.account_bank = '';
      // self.form.baseInfo.account_number = '';
      // self.form.baseInfo.bank_name = '';
      // self.form.baseInfo.bank_branch_id = '';
      self.getBankList();
    },
    bank_account_typeChange(e) {
      let self = this;
      self.form.baseInfo.account_name = '';
      self.form.baseInfo.account_bank = '';
      self.form.baseInfo.account_number = '';
      self.form.baseInfo.bank_name = '';
      self.form.baseInfo.bank_branch_id = '';
      self.getBankList();
    },
    period_typeChange(e) {
      let self = this;
      if (self.form.qualificationInfo.period_type == '0') {
        if (isNil(self.form.qualificationInfo.period_begin)) {
          self.form.qualificationInfo.period_begin = ''
        } else {
          //默认增加10年
          self.form.qualificationInfo.period_begin = moment(new Date(self.form.qualificationInfo.period_begin), 'YYYY-MM-DD').add(10, 'years').format('YYYY-MM-DD')
        }
      } else {
        self.form.qualificationInfo.period_end = '长期';
      }
    },
    card_period_typeChange(e) {
      let self = this;
      if (self.form.qualificationInfo.card_period_type == '0') {
        if (isNil(self.form.qualificationInfo.card_period_begin)) {
          self.form.qualificationInfo.card_period_end = ''
        } else {
          //默认增加10年
          self.form.qualificationInfo.card_period_end = moment(new Date(self.form.qualificationInfo.card_period_begin), 'YYYY-MM-DD').add(10, 'years').format('YYYY-MM-DD')
        }
      } else {
        self.form.qualificationInfo.card_merBlisExpDt = '长期';
      }
    },
    getAreaData() {
      let self = this;
      DataApi.getRegion({}, true)
        .then(res => {
          self.areaList = res.data;
        })
        .catch(error => {
        });
    },
    getBankList() {
      let self = this;
      if (self.form.baseInfo.bank_account_type === 'BANK_ACCOUNT_TYPE_PERSONAL') {

      } else {

      }
      DataApi.getBanking({level: 1}, true)
        .then(res => {
          self.bankList = res.data;
        })
        .catch(error => {
        });
    },
    handleBankSelect(item) {
      this.form.baseInfo.bank_name = item.mergerName;
      this.form.baseInfo.bank_branch_id = item.number;
    },
    handleBankAddressChange(item) {

    },
    getBankBranchList(queryString, cb) {
      let self = this;
      if (self.form.baseInfo.account_bank === '其他银行') {
        let name = self.form.baseInfo.bank_name;
        if (name === '' && self.$refs.areaCascader.getCheckedNodes()[0]) {
          name = self.$refs.areaCascader.getCheckedNodes()[0].pathLabels[1].replace('市', '');
        }
        DataApi.getBanking({level: 2, pid: 23, name: name}, true)
          .then(res => {
            cb(res.data);
          })
          .catch(error => {
          });
      }
    },
    searchBanksByBankAccount(queryString) {
      let self = this;
      if (self.form.baseInfo.bank_account_type === 'BANK_ACCOUNT_TYPE_PERSONAL') {
        DataApi.getBanksByBankAccount({accountNumber: queryString}, true)
          .then(res => {
            //仅获取第一个
            let data = res.data.data[0];
            self.form.baseInfo.account_bank = data.bankAlias;
            if (data.needBankBranch) {
              self.form.baseInfo.account_bank === '其他银行';
            }
          })
          .catch(error => {
            self.form.baseInfo.account_bank = '';
          });
      }
    },
    getData(applymentId) {
      let self = this;
      // 取到路由带过来的参数
      SubApplymentApi.applymentDetail({
        applymentId: applymentId
      }, true)
        .then(res => {
          let detail = res.data;
          // 将数据放在当前组件的数据内
          self.form.baseInfo = JSON.parse(detail.baseInfo);
          self.form.qualificationInfo = JSON.parse(detail.qualificationInfo);
          self.license_copyFilePath = self.form.qualificationInfo.license_copy && self.form.qualificationInfo.license_copy.filePath;
          self.cert_copyFilePath = self.form.qualificationInfo.cert_copy && self.form.qualificationInfo.cert_copy.filePath;
          self.id_card_nationalFilePath = self.form.qualificationInfo.id_card_national && self.form.qualificationInfo.id_card_national.filePath;
          self.id_card_copyFilePath = self.form.qualificationInfo.id_card_copy && self.form.qualificationInfo.id_card_copy.filePath;
          self.form.applymentId = detail.applymentId;
          self.form.applymentNo = detail.applymentNo;
        })
        .catch(error => {

        });

    },
  },
  watch: {
    'payInfo': {
      handler(values, oldVal) {
        let oldTimeStamp = (typeof oldVal === 'undefined' ? 0 : oldVal.timeStamp);
        if (values.timeStamp && values.timeStamp != oldTimeStamp && values.applymentId) {
          this.getData(values.applymentId)
        }
      },
      immediate: true,
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>

.bank-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .code {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .code {
      color: #ddd;
    }
  }
}

.tips {
  color: #ccc;
}

.subject-wrap {
  background: #f6f8fb !important;
}

.product-add {
  padding-bottom: 20px;
}

.f-item {
  width: 100%;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>




// WEBPACK FOOTER //
// src/views/setting/applyment/part/Wepay.vue